import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Sun, Moon } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

const HeaderUtilityBar = ({ footerCfg = {}, lang, setLang, theme, toggleTheme, session }) => {
  // Hide the "Sell on TelanganaMart" CTA once the user is logged in as a vendor
  // — they're already a seller, so the link is noise (and on production it
  // led them back to /vendor/register, which is now also redirected away).
  const isVendor = session?.role === 'vendor';
  return (
  <div className="hidden lg:block bg-[#0f1f44] dark:bg-[#020617] text-white text-xs" data-testid="desktop-utility-bar">
    <div className="max-w-7xl mx-auto px-4 h-8 flex items-center justify-between gap-4">
      <div className="flex items-center gap-4">
        {footerCfg.contact_phone && (
          <a href={`tel:${footerCfg.contact_phone.replace(/\s/g, '')}`} className="inline-flex items-center gap-1.5 hover:text-[#ee5e23] transition-colors" data-testid="utility-phone">
            <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            <span>{footerCfg.contact_phone}</span>
          </a>
        )}
        {footerCfg.contact_email && (
          <a href={`mailto:${footerCfg.contact_email}`} className="hidden xl:inline-flex items-center gap-1.5 hover:text-[#ee5e23] transition-colors" data-testid="utility-email">
            <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            <span>{footerCfg.contact_email}</span>
          </a>
        )}
      </div>
      <div className="flex items-center gap-4">
        <Link to="/directory" className="hover:text-[#ee5e23] transition-colors" data-testid="utility-business-directory">Business Directory</Link>
        <Link to="/p/contact-us" className="hover:text-[#ee5e23] transition-colors" data-testid="utility-contact-us">Contact Us</Link>
        {!isVendor && (
          <Link to="/vendor/register" className="hover:text-[#ee5e23] transition-colors" data-testid="utility-sell">Sell on TelanganaMart</Link>
        )}
        <DropdownMenu>
          <DropdownMenuTrigger className="inline-flex items-center gap-1 hover:text-[#ee5e23] transition-colors" data-testid="utility-lang">
            <span className="uppercase tracking-wider">{lang}</span>
            <ChevronDown className="w-3 h-3" />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="min-w-[100px]">
            <DropdownMenuItem onClick={() => setLang('en')} data-testid="lang-en">English</DropdownMenuItem>
            <DropdownMenuItem onClick={() => setLang('te')} data-testid="lang-te">తెలుగు</DropdownMenuItem>
            <DropdownMenuItem onClick={() => setLang('hi')} data-testid="lang-hi">हिन्दी</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <button
          onClick={toggleTheme}
          className="inline-flex items-center hover:text-[#ee5e23] transition-colors"
          title={theme === 'dark' ? 'Switch to light' : 'Switch to dark'}
          data-testid="utility-theme-toggle"
        >
          {theme === 'dark' ? <Sun className="w-3.5 h-3.5" /> : <Moon className="w-3.5 h-3.5" />}
        </button>
      </div>
    </div>
  </div>
  );
};

export default HeaderUtilityBar;
